import {
   GET_PURCHASE_ORDER,
   ADD_PURCHASE_ORDER,
   UPDATE_PURCHASE_ORDER,
   GET_PURCHASE_ORDER_BY_ID,
   DELETE_PURCHASE_ORDER,
   GET_LAST_PURCHASE_ORDER_DAYBOOK,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   salesData: null,
   prevAndNext: null,
   pendingVoucherSalesAdjustment: [],
   pendingSalesAdjustment: [],
   pendingPurchaseAdjustment: [],
   pendingVoucherPurchaseAdjustment: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_PURCHASE_ORDER:
         return { ...state, list: payload.data, totalCount: totalCount, isLoading: false, pagination: action.payload.pagination };

      case GET_PURCHASE_ORDER_BY_ID:
         return { ...state, single: payload || initialState.single, isLoading: false };

      case UPDATE_PURCHASE_ORDER:
         return { ...state, list: state.list.map((item) => (item.id === payload.id ? payload : item)), isLoading: false };

      case ADD_PURCHASE_ORDER:
         return { ...state, list: [payload, ...state.list], totalCount: state.totalCount + 1, isLoading: false };

      case DELETE_PURCHASE_ORDER:
         return { ...state, list: state.list.filter((item) => item.id !== payload.id), totalCount: state.totalCount - 1, isLoading: false };

      case GET_LAST_PURCHASE_ORDER_DAYBOOK:
         return { ...state, lastPurchaseDaybook: payload };

      default:
         return state;
   }
};

export default reducer;
